type Detail = Record<string, string | number | boolean | null>;

// The one place the app reports problems. Only codes and states go in: never secrets, comment
// text or coordinates. Console is the V1 sink.
export function logEvent(event: string, detail: Detail = {}): void {
  console.warn(`[app] ${event}`, detail);
}

export function logError(event: string, error: unknown, detail: Detail = {}): void {
  const message = error instanceof Error ? `${error.name}: ${error.message}` : String(error);
  console.error(`[app] ${event}`, { ...detail, message: message.slice(0, 300) });
}
